import BaseAPI from './BaseAPI';

// Admin-only management of user accounts (the `users` table), under /auth/staff.
// Distinct from StaffAPI, which is the Square team-member roster (/staffs).
class AdminAPI extends BaseAPI {
  constructor() {
    super('auth/staff');
  }

  // GET /auth/staff → { staff: [...] }
  list() {
    return this.get();
  }

  // POST /auth/staff → { staff: {...} }
  create(data) {
    return this.post('', { body: data });
  }

  // POST /auth/staff/:id/reset-password → { status: 'success' }
  // `currentPassword` is required only when resetting your own account.
  resetPassword(id, password, currentPassword) {
    return this.post(`/${id}/reset-password`, { body: { password, currentPassword } });
  }
}

export const AdminService = new AdminAPI();
export default AdminAPI;
